import _ from "lodash";
import moment from "moment";

const isSameDay = (a, b) => (!a && !b) || (!!a && !!b && moment(a).isSame(moment(b), 'day'))

// Actions telles qu'enregistrées en base, par id. Les formulaires (« Travaux », « Opportunité », « Mes actions »)
// ne relisent ni ne renvoient doneDate / numberOfRevisions : ni le client ni l'ancien objet ne les portent.
export const storedActionsById = async ids => {
    const objectIds = _.compact(ids).filter(id => global.ObjectID.isValid(id)).map(id => new global.ObjectID(id))
    if (!objectIds.length) return {}
    const actions = await global.app.K.Action.collection
        .find({_id: {$in: objectIds}}, {projection: {status: 1, dueDate: 1, doneDate: 1, numberOfRevisions: 1}})
        .toArray()
    return _.keyBy(actions, action => action._id.toString())
}

// Règles d'une action à l'enregistrement, à partir de sa version en base (statuts sous forme d'identifiant).
// Appelées par Action.beforeSave et par les parents (WorkItem, Opportunity), car l'enregistrement en cascade
// des enfants OTM ne passe pas par leur beforeSave. Les valeurs posées ici sont bien écrites en base.
export const applyActionRules = (newAction, storedAction) => {
    if (!newAction.status) newAction.status = {id: 'todo'}

    // Une révision = une échéance existante modifiée (la première saisie ne compte pas)
    const revisions = _.get(storedAction, 'numberOfRevisions') || 0
    const dueDateChanged = !!_.get(storedAction, 'dueDate') && !isSameDay(storedAction.dueDate, newAction.dueDate)
    newAction.numberOfRevisions = dueDateChanged ? revisions + 1 : revisions

    const isDone = _.get(newAction, 'status.id') === 'done'
    const wasDone = _.get(storedAction, 'status') === 'done'
    newAction.doneDate = isDone
        ? (wasDone && storedAction.doneDate) || newAction.doneDate || new Date()
        : null

    return newAction
}

// Changement de statut d'une action déjà enregistrée : {id, from, to}, ou null
export const actionStatusChange = (newAction, storedAction) => {
    const from = _.get(storedAction, 'status')
    const to = _.get(newAction, 'status.id')
    return storedAction && from !== to ? {id: newAction.id, from, to} : null
}

// Applique les règles aux actions d'un parent et renvoie leurs changements de statut
export const applyChildrenActionRules = async newObject => {
    const actions = newObject.actions || []
    const stored = await storedActionsById(actions.map(action => action.id))
    actions.forEach(action => applyActionRules(action, stored[action.id]))
    return _.compact(actions.map(action => actionStatusChange(action, stored[action.id])))
}
